"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _buttonProps = _interopRequireDefault(require("./button-props"));
var _deprecate = _interopRequireDefault(require("../../utils/deprecate"));
(0, _deprecate.default)({
  name: 'Button',
  changes: ['iconPosition has been removed, iconLeft and iconRight have replaced it.', 'color is now variant and takes in new values.', 'block was removed, if full width is needed, use isFullWidth', 'loading was replaced by isLoading']
});
const Button = ({
  className,
  color,
  iconPosition,
  block,
  loading,
  asAnchor,
  type,
  ...attrs
}) => {
  const classes = (0, _classnames.default)('Button', {
    [`Button-${color}`]: color
  }, {
    'Button-block': block
  }, {
    'Button-loading': loading
  }, {
    [`Button-with-icon-${iconPosition}`]: iconPosition
  }, className);
  const {
    finalType,
    Element
  } = asAnchor ? {
    Element: 'a'
  } : {
    Element: 'button',
    finalType: type
  };
  return /*#__PURE__*/_react.default.createElement(Element, (0, _extends2.default)({
    className: classes,
    type: finalType
  }, attrs));
};
Button.defaultProps = {
  type: 'button'
};
var _default = exports.default = Button;